module.exports = __webpack_public_path__ + "static/media/serialSound.4977375b.mp3";